import {
    RETRIEVE_RESERVATIONS,
    UPDATE_RESERVATION_STATUS,
    UPDATE_RESERVATION_PAYMENT_STATUS,
    UPDATE_PAYOUT_HOLD_STATUS,
    UPDATE_PROMO_SENT_STATUS
} from "../actions/types";
  
  const initialState = { reservations : [], totalReservationCount : 0 };

const reservationReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_RESERVATIONS:
      return {
        reservations: payload.rows,
        totalReservationCount: payload.count,
      };

    case UPDATE_RESERVATION_STATUS:
      return {
        reservations: payload.rows,
        totalReservationCount: payload.count,
      };

    case UPDATE_RESERVATION_PAYMENT_STATUS:
      return {
        reservations: payload.rows,
        totalReservationCount: payload.count,
      };

    case UPDATE_PAYOUT_HOLD_STATUS:
      return {
        reservations: payload.rows,
        totalReservationCount: payload.count,
      };

    case UPDATE_PROMO_SENT_STATUS:
      return {
        reservations: payload.rows,
        totalReservationCount: payload.count,
      };

    default:
      return state;
  }
};

export default reservationReducer;